import React from 'react';
import { useWatch } from 'react-hook-form';

import { TwitterBlue } from '#components/Tasks/components/TwitterBlue';

export const TwitterBluePreview = ({ index }: { index: number }) => {
  const task = useWatch({
    name: `tasks.${index}`,
  });

  return <TwitterBlue task={task} preview={true} />;
};
